import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createStaticVNode as _createStaticVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-15c9ddcc")

_pushScopeId("data-v-15c9ddcc")
const _hoisted_1 = { class: "element-positopn-panel" }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = /*#__PURE__*/_createVNode("div", { style: {"flex":"3"} }, "位置：", -1)
const _hoisted_4 = /*#__PURE__*/_createVNode("div", { style: {"flex":"1"} }, null, -1)
const _hoisted_5 = /*#__PURE__*/_createStaticVNode("<div class=\"row\" data-v-15c9ddcc><div style=\"flex:3;\" data-v-15c9ddcc></div><div style=\"flex:4;\" class=\"label\" data-v-15c9ddcc>X</div><div style=\"flex:1;\" data-v-15c9ddcc></div><div style=\"flex:4;\" class=\"label\" data-v-15c9ddcc>Y</div></div>", 1)
const _hoisted_6 = { class: "row" }
const _hoisted_7 = /*#__PURE__*/_createVNode("div", { style: {"flex":"3"} }, "大小：", -1)
const _hoisted_8 = {
  key: 1,
  style: {"flex":"1"}
}
const _hoisted_9 = /*#__PURE__*/_createStaticVNode("<div class=\"row\" data-v-15c9ddcc><div style=\"flex:3;\" data-v-15c9ddcc></div><div style=\"flex:4;\" class=\"label\" data-v-15c9ddcc>宽</div><div style=\"flex:1;\" data-v-15c9ddcc></div><div style=\"flex:4;\" class=\"label\" data-v-15c9ddcc>高</div></div>", 1)
const _hoisted_10 = { class: "row" }
const _hoisted_11 = /*#__PURE__*/_createVNode("div", { style: {"flex":"3"} }, "旋转：", -1)
const _hoisted_12 = /*#__PURE__*/_createVNode("div", { style: {"flex":"1"} }, null, -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_IconSendToBack = _resolveComponent("IconSendToBack")
  const _component_Button = _resolveComponent("Button")
  const _component_Tooltip = _resolveComponent("Tooltip")
  const _component_IconBringToFrontOne = _resolveComponent("IconBringToFrontOne")
  const _component_IconBringToFront = _resolveComponent("IconBringToFront")
  const _component_IconSentToBack = _resolveComponent("IconSentToBack")
  const _component_ButtonGroup = _resolveComponent("ButtonGroup")
  const _component_IconAlignLeft = _resolveComponent("IconAlignLeft")
  const _component_IconAlignVertically = _resolveComponent("IconAlignVertically")
  const _component_IconAlignRight = _resolveComponent("IconAlignRight")
  const _component_IconAlignTop = _resolveComponent("IconAlignTop")
  const _component_IconAlignHorizontally = _resolveComponent("IconAlignHorizontally")
  const _component_IconAlignBottom = _resolveComponent("IconAlignBottom")
  const _component_Divider = _resolveComponent("Divider")
  const _component_InputNumber = _resolveComponent("InputNumber")
  const _component_IconLock = _resolveComponent("IconLock")
  const _component_IconUnlock = _resolveComponent("IconUnlock")
  const _component_IconRotate = _resolveComponent("IconRotate")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode(_component_ButtonGroup, { class: "row" }, {
      default: _withId(() => [
        _createVNode(_component_Tooltip, {
          mouseLeaveDelay: 0,
          mouseEnterDelay: 0.5,
          title: "置顶层"
        }, {
          default: _withId(() => [
            _createVNode(_component_Button, {
              style: {"flex":"1"},
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.orderElement(_ctx.handleElement, 'top')))
            }, {
              default: _withId(() => [
                _createVNode(_component_IconSendToBack)
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["mouseEnterDelay"]),
        _createVNode(_component_Tooltip, {
          mouseLeaveDelay: 0,
          mouseEnterDelay: 0.5,
          title: "置底层"
        }, {
          default: _withId(() => [
            _createVNode(_component_Button, {
              style: {"flex":"1"},
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.orderElement(_ctx.handleElement, 'bottom')))
            }, {
              default: _withId(() => [
                _createVNode(_component_IconBringToFrontOne)
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["mouseEnterDelay"]),
        _createVNode(_component_Tooltip, {
          mouseLeaveDelay: 0,
          mouseEnterDelay: 0.5,
          title: "上移一层"
        }, {
          default: _withId(() => [
            _createVNode(_component_Button, {
              style: {"flex":"1"},
              onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.orderElement(_ctx.handleElement, 'up')))
            }, {
              default: _withId(() => [
                _createVNode(_component_IconBringToFront)
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["mouseEnterDelay"]),
        _createVNode(_component_Tooltip, {
          mouseLeaveDelay: 0,
          mouseEnterDelay: 0.5,
          title: "下移一层"
        }, {
          default: _withId(() => [
            _createVNode(_component_Button, {
              style: {"flex":"1"},
              onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.orderElement(_ctx.handleElement, 'down')))
            }, {
              default: _withId(() => [
                _createVNode(_component_IconSentToBack)
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["mouseEnterDelay"])
      ]),
      _: 1
    }),
    _createVNode(_component_ButtonGroup, { class: "row" }, {
      default: _withId(() => [
        _createVNode(_component_Tooltip, {
          mouseLeaveDelay: 0,
          mouseEnterDelay: 0.5,
          title: "左对齐"
        }, {
          default: _withId(() => [
            _createVNode(_component_Button, {
              style: {"flex":"1"},
              onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.alignElementToCanvas('left')))
            }, {
              default: _withId(() => [
                _createVNode(_component_IconAlignLeft)
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["mouseEnterDelay"]),
        _createVNode(_component_Tooltip, {
          mouseLeaveDelay: 0,
          mouseEnterDelay: 0.5,
          title: "水平居中"
        }, {
          default: _withId(() => [
            _createVNode(_component_Button, {
              style: {"flex":"1"},
              onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.alignElementToCanvas('horizontal')))
            }, {
              default: _withId(() => [
                _createVNode(_component_IconAlignVertically)
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["mouseEnterDelay"]),
        _createVNode(_component_Tooltip, {
          mouseLeaveDelay: 0,
          mouseEnterDelay: 0.5,
          title: "右对齐"
        }, {
          default: _withId(() => [
            _createVNode(_component_Button, {
              style: {"flex":"1"},
              onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.alignElementToCanvas('right')))
            }, {
              default: _withId(() => [
                _createVNode(_component_IconAlignRight)
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["mouseEnterDelay"])
      ]),
      _: 1
    }),
    _createVNode(_component_ButtonGroup, { class: "row" }, {
      default: _withId(() => [
        _createVNode(_component_Tooltip, {
          mouseLeaveDelay: 0,
          mouseEnterDelay: 0.5,
          title: "上对齐"
        }, {
          default: _withId(() => [
            _createVNode(_component_Button, {
              style: {"flex":"1"},
              onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.alignElementToCanvas('top')))
            }, {
              default: _withId(() => [
                _createVNode(_component_IconAlignTop)
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["mouseEnterDelay"]),
        _createVNode(_component_Tooltip, {
          mouseLeaveDelay: 0,
          mouseEnterDelay: 0.5,
          title: "垂直居中"
        }, {
          default: _withId(() => [
            _createVNode(_component_Button, {
              style: {"flex":"1"},
              onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.alignElementToCanvas('vertical')))
            }, {
              default: _withId(() => [
                _createVNode(_component_IconAlignHorizontally)
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["mouseEnterDelay"]),
        _createVNode(_component_Tooltip, {
          mouseLeaveDelay: 0,
          mouseEnterDelay: 0.5,
          title: "下对齐"
        }, {
          default: _withId(() => [
            _createVNode(_component_Button, {
              style: {"flex":"1"},
              onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.alignElementToCanvas('bottom')))
            }, {
              default: _withId(() => [
                _createVNode(_component_IconAlignBottom)
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["mouseEnterDelay"])
      ]),
      _: 1
    }),
    _createVNode(_component_Divider),
    _createVNode("div", _hoisted_2, [
      _hoisted_3,
      _createVNode(_component_InputNumber, {
        step: 5,
        value: _ctx.left,
        onChange: _cache[11] || (_cache[11] = value => _ctx.updateLeft(value)),
        style: {"flex":"4"}
      }, null, 8, ["value"]),
      _hoisted_4,
      _createVNode(_component_InputNumber, {
        step: 5,
        value: _ctx.top,
        onChange: _cache[12] || (_cache[12] = value => _ctx.updateTop(value)),
        style: {"flex":"4"}
      }, null, 8, ["value"])
    ]),
    _hoisted_5,
    (_ctx.handleElement.type !== 'line')
      ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
          _createVNode("div", _hoisted_6, [
            _hoisted_7,
            _createVNode(_component_InputNumber, {
              min: _ctx.minSize,
              max: 1500,
              step: 5,
              value: _ctx.width,
              onChange: _cache[13] || (_cache[13] = value => _ctx.updateWidth(value)),
              style: {"flex":"4"}
            }, null, 8, ["min", "value"]),
            (['image', 'shape'].includes(_ctx.handleElement.type))
              ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
                  (_ctx.fixedRatio)
                    ? (_openBlock(), _createBlock(_component_Tooltip, {
                        key: 0,
                        mouseLeaveDelay: 0,
                        mouseEnterDelay: 0.5,
                        title: "解除宽高比锁定"
                      }, {
                        default: _withId(() => [
                          _createVNode(_component_IconLock, {
                            style: {"flex":"1"},
                            class: "icon-btn",
                            onClick: _cache[14] || (_cache[14] = ($event: any) => (_ctx.updateFixedRatio(false)))
                          })
                        ]),
                        _: 1
                      }, 8, ["mouseEnterDelay"]))
                    : (_openBlock(), _createBlock(_component_Tooltip, {
                        key: 1,
                        mouseLeaveDelay: 0,
                        mouseEnterDelay: 0.5,
                        title: "宽高比锁定"
                      }, {
                        default: _withId(() => [
                          _createVNode(_component_IconUnlock, {
                            style: {"flex":"1"},
                            class: "icon-btn",
                            onClick: _cache[15] || (_cache[15] = ($event: any) => (_ctx.updateFixedRatio(true)))
                          })
                        ]),
                        _: 1
                      }, 8, ["mouseEnterDelay"]))
                ], 64))
              : (_openBlock(), _createBlock("div", _hoisted_8)),
            _createVNode(_component_InputNumber, {
              min: _ctx.minSize,
              max: 800,
              step: 5,
              disabled: _ctx.handleElement.type === 'text',
              value: _ctx.height,
              onChange: _cache[16] || (_cache[16] = value => _ctx.updateHeight(value)),
              style: {"flex":"4"}
            }, null, 8, ["min", "disabled", "value"])
          ]),
          _hoisted_9
        ], 64))
      : _createCommentVNode("", true),
    (['text', 'image', 'shape'].includes(_ctx.handleElement.type))
      ? (_openBlock(), _createBlock(_Fragment, { key: 1 }, [
          _createVNode(_component_Divider),
          _createVNode("div", _hoisted_10, [
            _hoisted_11,
            _createVNode(_component_Tooltip, {
              mouseLeaveDelay: 0,
              mouseEnterDelay: 0.5,
              title: "逆时针旋转"
            }, {
              default: _withId(() => [
                _createVNode(_component_IconRotate, {
                  class: "icon-btn",
                  onClick: _cache[17] || (_cache[17] = ($event: any) => (_ctx.updateRotate45('-'))),
                  style: {"flex":"2"}
                })
              ]),
              _: 1
            }, 8, ["mouseEnterDelay"]),
            _createVNode(_component_Tooltip, {
              mouseLeaveDelay: 0,
              mouseEnterDelay: 0.5,
              title: "顺时针旋转"
            }, {
              default: _withId(() => [
                _createVNode(_component_IconRotate, {
                  class: "icon-btn",
                  onClick: _cache[18] || (_cache[18] = ($event: any) => (_ctx.updateRotate45('+'))),
                  style: {
              flex: 2,
              transform: 'rotateY(180deg)',
            }
                }, null, 8, ["style"])
              ]),
              _: 1
            }, 8, ["mouseEnterDelay"]),
            _hoisted_12,
            _createVNode(_component_InputNumber, {
              min: -180,
              max: 180,
              step: 5,
              value: _ctx.rotate,
              onChange: _cache[19] || (_cache[19] = value => _ctx.updateRotate(value)),
              style: {"flex":"4"}
            }, null, 8, ["value"])
          ])
        ], 64))
      : _createCommentVNode("", true)
  ]))
})